import { Link as RouterLink } from 'react-router-dom'

import { styled } from '@mui/material/styles'
import { Card, Stack, Grid, Container, Typography } from '@mui/material'

import AuthLayout from '../../layouts/AuthLayout'

import Page from '../../components/Page'
import LogoSmall from '../../components/LogoSmall'
import { LoginForm } from '../../sections/authentication/startup'

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    minHeight: '100vh',
    padding: '20px 0',
    backgroundColor: '#f6f6f6',
    boxSizing: 'border-box',
  },
}))

const SectionStyle = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  borderTopLeftRadius: '0',
  borderBottomLeftRadius: '0',
  borderTopRightRadius: '55px',
  borderBottomRightRadius: '55px',
  // margin: theme.spacing(2, 0, 2, 2),
  '& .image': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: '#fff',
  borderTopLeftRadius: '55px',
  borderBottomLeftRadius: '55px',
  padding: theme.spacing(5, 10),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 1, 0, 1),
  },
}))

export default function LoginStartup() {
  return (
    <RootStyle title='ورود'>
      {/* <AuthLayout /> */}
      <Container maxWidth='lg'>
        <Grid container sx={{ height: '100%' }}>
          <Grid items xs={12} md={6} lg={7} sx={{ height: '100%' }}>
            <ContentStyle>
              <Stack
                direction='row'
                sx={{ mb: 5, alignItems: 'center' }}
                spacing={2}
              >
                <LogoSmall />
                <Typography variant='h4' gutterBottom>
                  ورود به پنل ادمین
                </Typography>
              </Stack>
              <LoginForm />
            </ContentStyle>
          </Grid>
          <Grid items xs={12} md={6} lg={5} sx={{ height: '100%' }}>
            <SectionStyle sx={{ display: { xs: 'none', md: 'flex' } }}>
              <img src='/static/ryan-admin.jpg' className='image' alt='login' />
            </SectionStyle>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  )
}
